import React, { useEffect, useState } from 'react'
import StarIcon from '@mui/icons-material/Star';
import StairsIcon from '@mui/icons-material/Stairs';
import { Oval } from 'react-loader-spinner';
// import ProgressBar from "@ramonak/react-progress-bar";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { baseUrl, path } from '../../constants';
import { Link } from 'react-router-dom';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HistoryIcon from '@mui/icons-material/History';
import {api} from '../../api'
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'react-toastify';

export default function Finance() {
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)
    const [history, setHistory] = useState(false)
    const [cashout, setCashout] = useState(false)

    const fetchFinance = () => {
        api.get(path.finance).then(response => {
            const data = response.data
            if(data.success){
                setData(data)
            }
        })
    }

    useEffect(fetchFinance, [])
    
  return ( 
    <div className='flex flex-col flex-1 overflow-auto gap-4'>
            <div className='w-full flex justify-between items-center max-md:items-stretch p-4 bg-main rounded-md shadow-sm max-md:flex-col max-md:gap-4'>
                <p className='text-white font-bold text-[18px] max-md:text-[14px]'>Hulluware Finance</p>
                {/* <p className='text-main text-[14px] px-4 py-2 rounded-sm bg-white font-bold'>Company Earning { (parseFloat(data.total_in || 0)?.toLocaleString('en-US', {maximumFractionDigits: 2})) + ' ETB'}</p> */}
                {/* <p className='text-main text-[14px] px-4 py-2 rounded-sm bg-white font-bold'>Total Owe to Sellers {(parseFloat(data.balance || 0)?.toLocaleString('en-US', {maximumFractionDigits: 2})) + ' ETB'}</p> */}
                <div className='flex items-center gap-2 max-md:justify-center'>
                    <button onClick={() => setCashout(true)} className='bg-black px-4 py-2 font-bold text-white rounded-md flex items-center justify-center gap-1 max-md:text-xs'>
                        <AccountBalanceIcon style={{color: '#ffffff', fontSize: 17}}>Filled</AccountBalanceIcon>
                        Cash Out
                    </button>
                    <button onClick={() => setHistory(true)} className='bg-black px-4 py-2 font-bold text-white rounded-md flex items-center justify-center gap-1 max-md:text-xs'>
                        <HistoryIcon style={{color: '#ffffff', fontSize: 17}}>Filled</HistoryIcon>
                        Cashout History
                    </button>
                </div>
            </div>
            {loading ? (
                <div className='flex flex-col items-center gap-3'>
                    <p className='text-black text-[15px]'>Loading data...</p>
                    <Oval
                        visible={true}
                        height="30"
                        width="30"
                        color="#52a4e0"
                        secondaryColor="#ffffff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                        />
                </div>
            ) : (
                <>
                    <div className='w-full flex items-center gap-4'>
                        <div className='bg-white rounded-md p-6 flex flex-col gap-1 flex-1 items-center'>
                            <h1 className='text-black font-bold text-[25px] leading-none'>{data?.company?.total_in} ETB</h1>
                            <p className='text-[13px] text-black'>Total Company Earning</p>
                        </div>
                        <div className='bg-white rounded-md p-6 flex flex-col gap-1 items-center flex-1'>
                            <h1 className='text-black font-bold text-[25px] leading-none'>{data?.company?.balance} ETB</h1>
                            <p className='text-[13px] text-black'>Company Balance</p>
                        </div>
                    </div>
                    <div className='w-full flex items-center gap-4'>
                        <div className='bg-white rounded-md p-6 flex flex-col gap-1 flex-1 items-center'>
                            <h1 className='text-black font-bold text-[25px] leading-none'>{data?.owe?.total_out} ETB</h1>
                            <p className='text-[13px] text-black'>Total Paid Amount</p>
                        </div>
                        <div className='bg-white rounded-md p-6 flex flex-col gap-1 items-center flex-1'>
                            <h1 className='text-black font-bold text-[25px] leading-none'>{data?.owe?.balance} ETB</h1>
                            <p className='text-[13px] text-black'>To Be Paid</p>
                        </div>
                    </div>
                </>
            )} 
            {cashout && <Cashout balance={data?.company?.balance || 0} setCashout={setCashout} refetch={fetchFinance} />}
            {history && <CashoutlHistory _setHistory={setHistory} />}
        </div>
    )
}


function Cashout({ balance, setCashout, refetch }){
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState(!balance)

    const requestWithdraw = (e) => {
        e.preventDefault()
        if(parseInt(e.target.amount.value) > balance) return setError(true)
        setError(false)
        setSubmitting(true)
        api(path.cashout + '/', {
            method: 'post',
            data: {
                remark: e.target.remark.value,
                amount: e.target.amount.value,
            }
        }).then(response => {
            if(response.data.success){
                toast.success('Success!.', {
                    hideProgressBar: true
                })
                setCashout(null)
                refetch()
            } else {
                toast.error('Sorry. something went wrong!', {
                    hideProgressBar: true
                })
            }
        }).finally(() => setSubmitting(false))
    }

    return (
        <div className='fixed bg-[#00000060] z-[999999] inset-0 flex items-center justify-center'>
            <form onSubmit={requestWithdraw} className='bg-white flex flex-col items-center gap-6 p-4 rounded-md'>
                <h1>Cashout <span className='font-bold'>(Balance {balance} ETB)</span></h1>
                {error && <p className='text-[#ff0000] text-sm bg-[#ff000040] px-4 py-2 rounded-md text-center font-bold'>Insufficient Balance!</p>}
                <input name='amount' placeholder={'Amount'} type='number' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-[300px]' required/>
                <input name='remark' placeholder={'Remark'} type='text' className='border-[1px] border-solid border-[#00000090] text-black placeholder:text-[#434343] p-2 w-[300px]'/>
                <div className='flex self-stretch gap-2'>
                    <button disabled={submitting || !balance} type='submit' className={`${(!balance) ? 'bg-[#a3a3a3]' : 'bg-main'} text-white text-[14px] flex-1 p-2 flex items-center justify-center`}>
                    {submitting ? (
                            <Oval
                                visible={true}
                                height="21"
                                width="21"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                                strokeWidth={3}
                            />
                        ) : 'Cashout'}
                    </button>
                    <button onClick={() => setCashout(false)} className='border-[1px] border-[#00000070] p-2 text-[14px] flex-1'>
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    )
}


function CashoutlHistory({ _setHistory }){
    const [loading, setLoading] = useState(true)
    const [history, setHistory] = useState([])

    const fetchHistory = (e) => {
        api.get(path.cashout).then(response => {
            let data = response.data
            if(data.success){
                setHistory(data.history)
            }
        }).finally(() => setLoading(false))
    }

    useEffect(fetchHistory, [])

    return (
        <div className='fixed bg-[#00000060] z-[999999] inset-0 flex items-center justify-center p-4'>
            <div className='bg-white flex flex-col items-center max-md:items-start overflow-x-auto gap-6 p-1 rounded-md relative'>
           
            {loading ? (
                <div className='flex flex-col items-center gap-3'>
                    <p className='text-black text-[15px]'>Loading history...</p>
                    <Oval
                        visible={true}
                        height="30"
                        width="30"
                        color="#52a4e0"
                        secondaryColor="#ffffff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        strokeWidth={3}
                        />
                </div>
            ) :(
                <table className='earnings'>
                    <thead className='bg-black'>
                        <tr className='text-white text-left'>
                            <th className='p-2 px-6 max-md:text-xs'>Amount</th>
                            <th className='p-2 px-6 max-md:text-xs'>Remark</th>
                            <th className='p-2 px-6 max-md:text-xs'>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history?.map(history => (
                            <tr>
                                <td className='p-2 max-md:text-xs'>{history.amount}</td>
                                <td className='p-2 max-md:text-xs'>{history.remark}</td>
                                <td className='p-2 max-md:text-xs'>{history.createdAt?.split('T')?.at(0)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
             {!loading && !history.length && <p>No cashout history yet!</p>}
             <button onClick={() => _setHistory(false)} className='outline-none bg-white rounded-full bg-none self-center'>
                <CancelIcon style={{fontSize: 25, color: '#000000'}}>Filled</CancelIcon>
             </button>
            </div>
            
        </div>
    )
}